/**
 * pf
 */
export default
    {
        path: "/ld",
        component: () => import('@/views/MainContent/MainContent'),
        children: [
            {
                path: 'member-center/homepage',
                name: 'homepage',
                component: () => import('@/views/bs/member-center/HomePage'),
                meta: {
                    keepAlive: false,
                    title: '任务管理'
                }
            },
            {
                path: 'task/list',
                name: 'TaskListId',
                component: () => import('@/views/ID/TaskList'),
                meta: {
                    keepAlive: false,
                    title: '任务池'
                }
            },
            {
                path: 'task/received',
                name: 'TaskTags',
                component: () => import('@/views/pf/task/TaskTags'),
                meta: {
                    keepAlive: false,
                    title: '已接任务'
                }
            },
            {
                path: 'task/scan',
                name: 'TaskScan',
                component: () => import('@/views/ID/scan'),
                meta: {
                    keepAlive: false,
                    title: '扫描收货'
                }
            },
            {
                path: 'task/complaint',
                name: 'TaskTags',
                component: () => import('@/views/pf/task/ComplaintTags'),
                meta: {
                    keepAlive: true,
                    title: '投诉列表'
                }
            },
            {
                path: 'user/service-list',
                name: 'service-list',
                component: () => import('@/views/ID/service-list'),
                meta: {
                    keepAlive: true,
                    title: '刷手列表'
                }
            },
            {
                path: 'acct/list',
                name: 'JsServiceSettlement',
                component: () => import('@/views/pf/acct/ServiceSettlementDjs'),
                meta: {
                    keepAlive: true,
                    title: '佣金账单'
                }
            }

        ]

    }


// WEBPACK FOOTER //
// ./src/router/id.js